import { Journey, journeyToJourneyDetails } from '@audibene/ta.utils-opportunity'
import { useMemo } from 'react'
import { AppointmentType } from '../../constants'
import { appointmentTypeOptions } from '../../util'
import { useShouldRestrictToHAE } from '../useShouldRestrictToHAE'
import { deliveryModelToAppointmentTypes } from 'util/deliveryModelToAppointmentType'

/**
 * Hook to filter appointment type options based on consultant restrictions
 * Returns filtered appointment type options when consultant restrictions apply
 */
const useFilteredAppointmentTypeOptions = (journey?: Journey | string) => {
  const shouldRestrictToHAE = useShouldRestrictToHAE(journey)

  const filteredOptions = useMemo(() => {
    if (shouldRestrictToHAE) {
      return appointmentTypeOptions.filter((option) => option.value === AppointmentType.HEARING_AID_EVALUATION)
    }

    if (!journey || !journeyToJourneyDetails[journey as Journey]) {
      return appointmentTypeOptions
    }

    const { deliveryModel } = journeyToJourneyDetails[journey as Journey]
    const allowedAppointmentTypes = deliveryModelToAppointmentTypes(deliveryModel)

    return appointmentTypeOptions.filter((option) => allowedAppointmentTypes.includes(option.value))
  }, [shouldRestrictToHAE, journey])

  return {
    appointmentTypeOptions: filteredOptions,
    shouldRestrictToHAE,
  }
}

export { useFilteredAppointmentTypeOptions }
